import { Feature } from '@sdk/common/features';
import gettext from '@sdk/lang/gettext';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import PremiumGuard from '@web/premiumGuard/PremiumGuard';
import { PremiumModalNames } from '@web/premiumGuard/constants/modalNames';
import CrownSvg from '@web/assets/svg/UI/crown.svg';
import {
  Button,
  Description,
  Subtitle,
  Title,
} from '@web/premiumGuard/featurePreview/featurePreview.styles';
import getRequiredSubscriptionNameForFeature from '@web/account/utils/getRequiredSubscriptionNameForFeature';

import ConversationModulePreview from './assets/images/conversation-module.png';
import { Info, Preview, PreviewCaption, Wrapper } from './featurePreview.styles';

type Props = {
  withPremiumGuard?: boolean;
  feature: Feature;
  currentUser: AuthUserType;
};

export const FeaturePreview = ({ feature, currentUser, withPremiumGuard = false }: Props) => {
  const requiredSubscriptionName = getRequiredSubscriptionNameForFeature(feature, currentUser);

  return (
    <Wrapper>
      <Info>
        <header>
          <Title>{gettext('Communicate more efficiently from a single platform')}</Title>
          <Subtitle>
            <CrownSvg aria-hidden={true} />{' '}
            {gettext('Available in %(requiredSubscriptionName)s', { requiredSubscriptionName })}
          </Subtitle>
        </header>

        <Description>
          {gettext(
            'Send messages to groups or individuals, keep everyone informed and build a better company culture. Easily reach employees within groups, locations or specific positions and get notified of their responses in real time.'
          )}
        </Description>

        {withPremiumGuard && (
          <PremiumGuard
            hasAccess={false}
            premiumFeature={feature}
            premiumGuardModalName={PremiumModalNames.messages}>
            <Button>{gettext('Learn more >')}</Button>
          </PremiumGuard>
        )}
      </Info>

      <Preview>
        <img src={ConversationModulePreview} height="520" width="1180" alt="" />
        <PreviewCaption>{gettext('Messages module preview')}</PreviewCaption>
      </Preview>
    </Wrapper>
  );
};
